import { PageHeader } from '@/components/layout/page-header';
import { TransactionsPanel } from '@/features/transactions/transactions-panel';

// Standalone /operations/transactions page: the bare panel over all users, no
// download button. The user page later embeds the same panel with
// { accountHolderId, enableDownload } props.
const TransactionsPage = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <PageHeader title="Transactions" />
      <TransactionsPanel />
    </div>
  );
};
TransactionsPage.displayName = 'TransactionsPage';

export default TransactionsPage;
